import {
    Box,
    Flex,
    Text,
    Divider,
    VStack,
    Button,
    HStack,
    Select,
    useDisclosure,
    useColorModeValue,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverBody,
} from "@chakra-ui/react";
import { Calendar } from "@/components/UI/Calendar";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { formatBarcodeMask, formatCurrency, formatDateLabel } from "@/utils";
import { usePayment } from "@/hooks/usePayment";

  
export function BankSlipConfirmStep() {
    const { bankSlipData, handleEditBankSlipRecipient } = usePayment(); 
    const bgCard = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("#E2E2E2", "gray.700");
  
    const formattedAmount = formatCurrency({
      value: bankSlipData?.amount ?? 0,
    });
    const formattedBarcode = formatBarcodeMask(bankSlipData?.bankSlipKey);
  
    const [transferDate, setTransferDate] = useState<Date>(
        bankSlipData?.paymentDate ? new Date(`${bankSlipData.paymentDate}T00:00:00`) : new Date()
    );
    const [costCenter, setCostCenter] = useState("");
  
    const costCenters = [
      { value: "Financeiro", label: "Financeiro" },
      { value: "Marketing", label: "Marketing" },
      { value: "Operacional", label: "Operacional" },
      { value: "Administrativo", label: "Administrativo" },
    ];
  
    const handleSaveDate = () => {
      handleEditBankSlipRecipient({ paymentDate: format(transferDate, "yyyy-MM-dd") });
      datePopover.onClose();
    };
  
    const handleSaveCost = () => {
      handleEditBankSlipRecipient({ costCenter: costCenter });
      costPopover.onClose();
    };
  
    const datePopover = useDisclosure();
    const costPopover = useDisclosure();
  
    const dateLabel = formatDateLabel(transferDate);
    useEffect(() => {
      if(!bankSlipData.costCenter || !bankSlipData.paymentDate) {
        handleEditBankSlipRecipient({ costCenter: costCenter });
        handleEditBankSlipRecipient({ paymentDate: format(transferDate, "yyyy-MM-dd") })
      }
    }, [])
  
    return (
      <Flex 
        w="100%" 
        h="100%" 
        justify="center"
        direction="column"  
        gap={6}
      >
        <Text fontSize="22px" fontWeight="400">
          Revise os dados do pagamento
        </Text>
  
        <Box>
          <Text fontSize="16px" color="gray.600">
            Total a pagar
          </Text>
          <Text fontSize="40px" fontWeight="bold">
            {formattedAmount}
          </Text>
        </Box>
  
        <Box border="1px solid" borderColor={borderColor} borderRadius="12px" bg={bgCard}>
          <VStack spacing={0} align="stretch" divider={<Divider />}>
            <Row label="Beneficiário" value={bankSlipData?.recipientName || "—"} />
            <Row label="Razão social" value={bankSlipData?.recipientDocument || "—"} />
            <EditableRow
              label="Data de pagamento"
              value={dateLabel}
              action="Agendar"
              isOpen={datePopover.isOpen}
              onOpen={datePopover.onOpen}
              onClose={datePopover.onClose}
            >
              <Calendar
                value={transferDate}
                onSelect={(d) => setTransferDate(d || new Date())}
                minDate={new Date()}
              />
              <Button mt={2} size="sm" variant="ghost" colorScheme="pink" onClick={handleSaveDate}>
                OK
              </Button>
            </EditableRow>
  
            <EditableRow
              label="Centro de custo"
              value={costCenter}
              action="Editar"
              isOpen={costPopover.isOpen}
              onOpen={costPopover.onOpen}
              onClose={costPopover.onClose}
            >
              <Select
                value={costCenter}
                onChange={(e) => setCostCenter(e.target.value)}
                size="sm"
                borderColor="#E2E2E2"
              >
                {costCenters.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </Select>
              <Button mt={2} size="sm" variant="ghost" colorScheme="pink" onClick={handleSaveCost}>
                OK
              </Button>
            </EditableRow>
          </VStack>
        </Box>
        <Box border="1px solid" borderColor={borderColor} borderRadius="12px" bg={bgCard}>
            <VStack spacing={0} align="stretch" divider={<Divider />}>
            {/* <Row label="Banco" value={bankSlipData?.issuer || "—"} /> */}
            <Flex direction="column" p={4}>
                <Text fontSize="sm" color="gray.500">
                Código de barras
                </Text>
                <Text fontWeight="medium" wordBreak="break-word">
                {formattedBarcode}
                </Text>
            </Flex>
            </VStack>
        </Box>
      </Flex>
    );
}

function Row({ label, value }: { label: string; value?: string }) {
    return (
        <Flex align="center" justify="space-between" p={4}>
            <Text fontSize="sm" color="gray.500">
                {label}
            </Text>
            <Text fontWeight="medium">{value}</Text>
        </Flex>
    );
}
  
function EditableRow({
    label,
    value,
    action,
    children,
    isOpen,
    onOpen,
    onClose,
}: {
    label: string;
    value?: string;
    action: string;
    children: React.ReactNode;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
}) {
return (
    <Flex align="center" justify="space-between" p={4}>
    <Text fontSize="sm" color="gray.500">
        {label}
    </Text>
    <HStack spacing={2}>
        {value && <Text fontWeight="medium">{value}</Text>}

        <Popover placement="left" isOpen={isOpen} onClose={onClose} closeOnBlur>
        <PopoverTrigger>
            <Text
            fontSize="sm"
            color="#CB2159"
            fontWeight="medium"
            cursor="pointer"
            _hover={{ textDecoration: "underline" }}
            onClick={onOpen}
            >
            {action}
            </Text>
        </PopoverTrigger>

        <PopoverContent w="auto" minW="240px" borderColor="#E2E2E2" boxShadow="lg" p={3}>
            <PopoverArrow />
            <PopoverBody>{children}</PopoverBody>
        </PopoverContent>
        </Popover>
    </HStack>
    </Flex>
);
}